module.exports = __webpack_public_path__ + "img/logo.1913d232.png";